export default __webpack_public_path__ + "static/media/forgotPswd.cbef6eb2.jpeg";